import {
  AzureMapPerCitySchema,
  DashboardCountsSchema,
  GeographicDistributionSchema,
  SubscriptionsPerProductSchema,
} from "../api/schema";
import { UsageRateType } from "../api/types";

export const DUMMY_DASHBOARD_COUNTS: DashboardCountsSchema = {
  hihVisitCount: 3842,
  konsultaSubmittedCount: 1567,
};

export const DUMMY_USAGE_RATE: UsageRateType[] = [
  { label: "Health Information Hub", value: 3842, marketShare: "45.2%", ranking: "1st Place", isShared: false },
  { label: "Konsulta", value: 1567, marketShare: "18.4%", ranking: "2nd Place", isShared: false },
  { label: "EClaims", value: 892, marketShare: "10.5%", ranking: "3rd Place", isShared: false },
  { label: "BMD", value: 234, marketShare: "2.8%", ranking: "4th Place", isShared: false },
];

export const DUMMY_SUBSCRIPTIONS: SubscriptionsPerProductSchema[] = [
  { productId: 1, productName: "Health Information Hub", facilities: 94, clients: 38, iconUrl: null },
  { productId: 2, productName: "Konsulta", facilities: 71, clients: 25, iconUrl: null },
  { productId: 3, productName: "EClaims", facilities: 48, clients: 17, iconUrl: null },
  { productId: 4, productName: "BMD", facilities: 33, clients: 12, iconUrl: null },
];

export const DUMMY_GEOGRAPHIC: GeographicDistributionSchema[] = [
  {
    rank: 1,
    regionName: "National Capital Region (NCR)",
    facilities: 134,
    topProduct: "Health Information Hub",
    growthPercentage: 12.5,
    distribution: [
      { label: "Health Information Hub", value: 58, iconUrl: null },
      { label: "Konsulta", value: 40, iconUrl: null },
      { label: "EClaims", value: 22, iconUrl: null },
      { label: "BMD", value: 14, iconUrl: null },
    ],
  },
  {
    rank: 2,
    regionName: "Region III (Central Luzon)",
    facilities: 98,
    topProduct: "Health Information Hub",
    growthPercentage: 8.0,
    distribution: [
      { label: "Health Information Hub", value: 44, iconUrl: null },
      { label: "Konsulta", value: 30, iconUrl: null },
      { label: "EClaims", value: 16, iconUrl: null },
      { label: "BMD", value: 8, iconUrl: null },
    ],
  },
  {
    rank: 3,
    regionName: "Region IV-A (CALABARZON)",
    facilities: 85,
    topProduct: "Konsulta",
    growthPercentage: 5.5,
    distribution: [
      { label: "Konsulta", value: 38, iconUrl: null },
      { label: "Health Information Hub", value: 27, iconUrl: null },
      { label: "EClaims", value: 13, iconUrl: null },
      { label: "BMD", value: 7, iconUrl: null },
    ],
  },
  {
    rank: 4,
    regionName: "Region VII (Central Visayas)",
    facilities: 72,
    topProduct: "Health Information Hub",
    growthPercentage: null,
    distribution: [
      { label: "Health Information Hub", value: 32, iconUrl: null },
      { label: "Konsulta", value: 22, iconUrl: null },
      { label: "EClaims", value: 12, iconUrl: null },
      { label: "BMD", value: 6, iconUrl: null },
    ],
  },
  {
    rank: 5,
    regionName: "Region XI (Davao Region)",
    facilities: 56,
    topProduct: "Konsulta",
    growthPercentage: 3.2,
    distribution: [
      { label: "Konsulta", value: 25, iconUrl: null },
      { label: "Health Information Hub", value: 18, iconUrl: null },
      { label: "EClaims", value: 9, iconUrl: null },
      { label: "BMD", value: 4, iconUrl: null },
    ],
  },
  {
    rank: 6,
    regionName: "Region I (Ilocos Region)",
    facilities: 43,
    topProduct: "Health Information Hub",
    growthPercentage: null,
    distribution: [
      { label: "Health Information Hub", value: 20, iconUrl: null },
      { label: "Konsulta", value: 13, iconUrl: null },
      { label: "EClaims", value: 7, iconUrl: null },
      { label: "BMD", value: 3, iconUrl: null },
    ],
  },
];

export const DUMMY_AZURE_CITIES: AzureMapPerCitySchema[] = [
  {
    cityName: "Manila",
    totalValues: 22,
    distribution: [
      { label: "Health Information Hub", value: 10, iconUrl: null },
      { label: "Konsulta", value: 7, iconUrl: null },
      { label: "EClaims", value: 3, iconUrl: null },
      { label: "BMD", value: 2, iconUrl: null },
    ],
  },
  {
    cityName: "Quezon City",
    totalValues: 18,
    distribution: [
      { label: "Health Information Hub", value: 8, iconUrl: null },
      { label: "Konsulta", value: 6, iconUrl: null },
      { label: "EClaims", value: 3, iconUrl: null },
      { label: "BMD", value: 1, iconUrl: null },
    ],
  },
  {
    cityName: "Cebu City",
    totalValues: 14,
    distribution: [
      { label: "Health Information Hub", value: 6, iconUrl: null },
      { label: "Konsulta", value: 5, iconUrl: null },
      { label: "EClaims", value: 2, iconUrl: null },
      { label: "BMD", value: 1, iconUrl: null },
    ],
  },
  {
    cityName: "Davao City",
    totalValues: 11,
    distribution: [
      { label: "Konsulta", value: 5, iconUrl: null },
      { label: "Health Information Hub", value: 4, iconUrl: null },
      { label: "EClaims", value: 2, iconUrl: null },
    ],
  },
  {
    cityName: "Cagayan de Oro",
    totalValues: 7,
    distribution: [
      { label: "Health Information Hub", value: 3, iconUrl: null },
      { label: "Konsulta", value: 2, iconUrl: null },
      { label: "BMD", value: 2, iconUrl: null },
    ],
  },
];
